module.exports = __webpack_public_path__ + "img/logo.3b56e4ca.svg";